module.exports = __webpack_public_path__ + "frontStatic/img/label1.182754ab.jpg";